const IframeService = {
    /**
     * True si l'app tourne dans une iframe (intégration site client).
     */
    isEmbedded() {
        try {
            return window.self !== window.top
        } catch (e) {
            // Accès cross-origin refusé : on est forcément dans une iframe
            return true
        }
    },

    /**
     * Hauteur (px) du header sticky de la page hôte : le scroll s'arrête d'autant
     * au-dessus du haut de l'iframe pour que le contenu ne passe pas dessous.
     * Surchargable par l'intégrateur via ?scrollOffset=<px> ; défaut = 60 (header printemps.com).
     */
    getScrollOffset() {
        const raw = new URLSearchParams(window.location.search).get('scrollOffset')
        const offset = parseInt(raw, 10)
        return isNaN(offset) ? 60 : offset
    },

    /**
     * Remonte la page HÔTE au niveau du haut de l'iframe (moins le scrollOffset).
     * No-op hors iframe ou si le parent n'a pas initialisé iFrameResize().
     */
    scrollParentToTop() {
        if ('parentIFrame' in window) {
            window.parentIFrame.scrollToOffset(0, -this.getScrollOffset())
        }
    },

    /**
     * Navigue vers une URL en sortant de l'iframe (fenêtre du haut),
     * avec repli sur la redirection classique (hors iframe, ou sandbox bloquant).
     */
    redirectTopLevel(url) {
        if (this.isEmbedded()) {
            try {
                window.top.location.href = url
                return
            } catch (e) {
                // SecurityError : iframe sandboxée sans allow-top-navigation
            }
        }
        window.location.href = url
    }
}

export default IframeService
